<div class="c__content" #content>
  @if (contentData?.tags?.length > 0) {
    <div class="c__tags">
      @for (tag of contentData?.tags; track tag) {
        <sd-tag [tagData]="tag" [isCopyTag]="tag?.isCopyTag" />
      }
    </div>
  }

  @if (contentData?.heading?.data && !hasNoHeadingData) {
    <sd-heading
      [isLoading]="isLoading"
      [inverted]="contentData?.heading?.isInverted"
      [size]="size"
      (noData)="checkData($event)"
      [readMore]="hasReadMore"
      [isUnderlined]="contentData?.heading?.isUnderlined || isUnderlined"
      [textConfig]="textConfig"
      [parentsThemesConfig]="parentsThemesConfig"
      [titleLevel]="titleLevel"
      [subtitleLevel]="subtitleLevel"
      [isInteractive]="hasHiddenLink"
      [isDescription]="isDescription"
      [heading]="contentData?.heading?.data"
    />
  }

  @if (contentData?.details?.title && contentData?.details?.description) {
    <span class="c__tooltip-wrapper">
      <sd-tooltip [position]="positionEnum.bottom">
        <span class="is-caption is-bold is-underline">{{ contentData?.details?.title }}</span>
        <ng-container sd-tooltip-template>
          <sd-html [html]="contentData?.details?.description" tag="div" />
        </ng-container>
      </sd-tooltip>
    </span>
  }

  @if (contentData?.links?.length && !hasHiddenLink && !isLoading && !hideButtonLink && !miniPush) {
    <div class="c__actions">
      @for (link of contentData?.links; track link) {
        @if (link?.linkName) {
          <sd-link [indexFollow]="indexFollow"
            [isButton]="true"
            [brand]="brand"
            (clicked)="onClick(link)"
            [theme]="$first && customTheme ? customTheme : link?.theme"
            [isSecondary]="link?.border"
            [link]="link"
          >
            <span>{{ link?.linkName }}</span>
          </sd-link>
        }
      }
    </div>
  }

  @if (contentData?.links?.length === 1 && hasHiddenLink && !isLoading && !miniPush) {
    <sd-link
      [indexFollow]="indexFollow"
      customClass="is-full-area"
      [brand]="brand"
      (clicked)="onClick(contentData?.links[0])"
      [link]="contentData?.links[0]"
    >
      <span class="is-visually-hidden">
        {{ 'actions.more' | translate }} - {{contentData?.heading?.data?.title}} - {{contentData?.heading?.data?.subtitle}}
      </span>
    </sd-link>
  }

  @if (miniPush) {
    <sd-link
      [link]="contentData?.links[0]"
      [brand]="brand"
      [buttonIconTitle]="contentData?.links[0]?.linkName"
      icon="icon-arrow-link"
      (clicked)="onClick(contentData?.links[0])"
      [iconPos]="positionEnum.right"
      [size]="iconSizeEnum.small"
    />
  }

  @if (contentData?.linksImages && !hasMediasLinksThumbnails && !isLoading && !miniPush) {
    <div class="c__actions is-media-link">
      @for (linkImage of contentData?.linksImages; track linkImage) {
        <sd-link
          [indexFollow]="indexFollow"
          customClass="is-reset"
          tabIndex="0"
          [brand]="brand"
          (clicked)="onClick(linkImage, $index)"
          [link]="linkImage"
        >
          <sd-banner [media]="linkImage?.media" [isFit]="!!linkImage?.url" />
          <span class="is-visually-hidden">
            {{ linkImage?.linkName }}
          </span>
        </sd-link>
      }
    </div>
  }

  @if (contentData?.footnote) {
    <sd-footnote
      [isLoading]="isLoading"
      [isSmall]="true"
      [textConfig]="textConfig"
      [parentsThemesConfig]="parentsThemesConfig"
      [footNotes]="[{note: contentData?.footnote}]"
    />
  }

  @if (contentData?.linksImages && hasMediasLinksThumbnails && !isLoading && !miniPush) {
    <div class="c__actions is-media-link is-thumbnail">
      @for (linkImage of contentData?.linksImages; track linkImage) {
        <button type="button" class="is-reset {{linkImage?.disable ? '' : 'is-active'}}" (click)="onClick(linkImage, $index)">
          <sd-banner [media]="linkImage?.media" [isFit]="!!linkImage?.url" />
          <span class="is-visually-hidden">
            {{ linkImage?.linkName }}
          </span>
        </button>
      }
    </div>
  }

  @if (hasPlayer && !isLoading) {
    <div class="c__play">
      <button sd-button
        (click)="onPlay()"
        [isPlayer]="true"
        [isIcon]="true"
        [brand]="brand"
        [theme]="themesEnum.light"
        icon="icon-play"
        type="button"
      >
        <span class="is-visually-hidden">
          {{ 'actions.start' | translate }}
        </span>
      </button>
    </div>
  }
</div>
